import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class AlarmTypeService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"alarmType")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByStatus(status:String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"alarmType/findByStatus/"+status)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(alarmType:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"alarmType",alarmType)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(alarmType:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"alarmType/"+alarmType.idAlarmType,alarmType)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:String){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"alarmType/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/alarm-type.service.ts